import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { fetchVersion } from "../lib/api";
import { setToken } from "../lib/auth";
import { oauthAvailable, startSsoLogin } from "../lib/oauth";

interface Props {
  onConnected: () => void;
}

export default function ConnectRoute({ onConnected }: Props) {
  const [token, setTokenInput] = useState("");
  const [status, setStatus] = useState("");
  const [ssoAvailable, setSsoAvailable] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    oauthAvailable().then(setSsoAvailable);
  }, []);

  async function connect() {
    setStatus("Verbinde...");
    try {
      const v = await fetchVersion();
      setToken(token.trim());
      setStatus(`Verbunden — core ${v.version}`);
      onConnected();
      nav("/system");
    } catch (e: any) {
      setStatus(`Fehler: ${e.message ?? e}`);
    }
  }

  async function sso() {
    setStatus("Weiterleitung zum IdP...");
    try {
      await startSsoLogin();
    } catch (e: any) {
      setStatus(`Fehler: ${e.message ?? e}`);
    }
  }

  return (
    <div className="max-w-xl mx-auto px-6 py-12 space-y-6">
      <h1 className="text-2xl font-semibold">Admin-Login</h1>

      {ssoAvailable && (
        <div className="space-y-2">
          <button
            onClick={sso}
            className="px-4 py-2 bg-kw-l3 text-white rounded text-sm font-medium hover:opacity-90"
          >
            Mit SSO anmelden
          </button>
          <div className="text-xs text-kw-text-muted">oder mit Bearer-Token (Operator/Solo) ↓</div>
        </div>
      )}

      <p className="text-sm text-kw-text-muted">
        Benötigt einen Bearer-Token mit <code className="text-kw-l3">kw:platform-admin</code>
        -Scope (oder den statischen <code>MCP_BEARER_TOKEN</code> im Solo-Mode).
        Token wird ausschließlich im LocalStorage gespeichert.
      </p>

      <label className="block">
        <span className="text-xs text-kw-text-muted">Bearer-Token</span>
        <input
          type="password"
          value={token}
          onChange={(e) => setTokenInput(e.target.value)}
          className="mt-1 w-full px-3 py-2 bg-kw-bg-elevated border border-kw-border-strong rounded text-sm font-mono"
          placeholder="kw-token-..."
        />
      </label>

      <button
        onClick={connect}
        disabled={!token.trim()}
        className="px-4 py-2 bg-kw-l3 text-white rounded text-sm font-medium disabled:opacity-50 hover:opacity-90"
      >
        Verbinden
      </button>

      {status && <div className="text-sm text-kw-text-muted">{status}</div>}
    </div>
  );
}
